export function formatMoneyOrDash(n) {
  if (n == null || n === "") return "—";
  const x = Number(n);
  if (!Number.isFinite(x)) return "—";
  return `$${Math.round(x).toLocaleString()}`;
}

/**
 * Format an ISO date (or any Date-parseable string) as "MM/DD/YYYY" using
 * the user's locale. Returns "—" for nullish / un-parseable inputs.
 */
export function formatSubmissionListDate(iso) {
  if (iso == null || iso === "") return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { month: "2-digit", day: "2-digit", year: "numeric" });
}

export function daysUntilDate(iso) {
  if (iso == null || iso === "") return null;
  const end = new Date(iso);
  if (Number.isNaN(end.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  return Math.round((end.getTime() - today.getTime()) / 86400000);
}

export function formatLocationOneLine(loc) {
  if (!loc) return "-";
  const parts = [
    loc.address1,
    loc.address2,
    loc.city,
    loc.state,
    loc.zipcode,
  ].filter((x) => x != null && String(x).trim() !== "").map((x) => String(x).trim());
  return parts.length ? parts.join(", ") : "-";
}
